import { Flex, IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const StyledIconWrapper = styled.div<{ active?: boolean; activeColor?: string }>`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: ${p => (p.active ? p.activeColor ?? 'var(--color-main-tint)' : 'var(--color-gray-100)')};
    border-radius: 8px;
    width: 32px;
    height: 32px;
`

export const ErrorTag = styled(IconFont)`
    position: absolute;
    top: -6px;
    right: -6px;
`

export const StyledItemTitle = styled.div`
    margin-bottom: 4px;
`

export const StyledActionLabel = styled.div`
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: var(--font-size-sm);
    margin-top: 2;
`

export const IconGroup = styled(Flex)`
    display: none;
`

export const ExecuteFilterCount = styled.div`
    display: inline-flex;
    align-items: center;
    height: 22px;
    padding: 0 8px;
    border-radius: 6px;
    background: var(--color-gray-100);
    color: var(--color-gray-500);
    font-size: var(--font-size-sm);
    user-select: none;
`
